module.exports = __webpack_public_path__ + "static/media/photo-06-cgv.a4157c98.png";